import { lazyForPaint } from 'react-loosely-lazy';
export const LazyReviewsTabV2 = lazyForPaint(() => import(/* webpackPrefetch: true, webpackChunkName: "chunk-reviews-v2-tab" */'./ReviewsTabV2'));